
// import MapUtils from '@/utils/MapUtils.js';
import EmployeeMap from '../employee/EmployeeMap';

export default class EmployeeEvents {
  
  constructor(eventsDomain) {
    this.eventsDomain = eventsDomain;
    this.domain = this.eventsDomain.domain;
  }
  
  contains(name) {
    if (name) {
      //
    }
    return false;
  }
  
  list(filter) {
    var event = EmployeeEvents.List.Request(filter);
    return this.eventsDomain.initRequest(event);
  }
  
  resend(employee) {
    var event = EmployeeEvents.Resend.Request(employee.company().find(), employee.user().find());
    return this.eventsDomain.initRequest(event);
  }

  reset(employee) {
    const user = employee.user().find();
    const company = employee.company().find();
    return this.domain.events().users().resetPassword(user.email(), company, true);
  }

  restore(employee) {
    var event = EmployeeEvents.Restore.Request(employee);
    return this.eventsDomain.initRequest(event);
  }
 
  save(employee) {
    return this.saveAll(new EmployeeMap(this.domain).add(employee));
  }

  addOrInvite(employee, sendEmail=false) {
    var event = EmployeeEvents.Add.Request(employee, sendEmail);
    return this.eventsDomain.initRequest(event);
  }
  
  saveAll(employeeMap) {
    var event = EmployeeEvents.Save.Request(employeeMap);
    return this.eventsDomain.initRequest(event);
  }
  
  remove(employee) {
    var event = EmployeeEvents.Remove.Request(employee);
    return this.eventsDomain.initRequest(event);
  }

  send(employee) {
    var event = EmployeeEvents.Resend.Request(employee.company().find(), employee.user().find());
    return this.eventsDomain.initRequest(event);
  }

  static Save = {
      Names: {
        Request: "EmployeeSaveRequestEvent",
        Response: "EmployeeSaveResponseEvent",
      },
      Errors: {
        
      },
      Request: function(employeeMap) {
        var event = {
            handler: EmployeeEvents.Save.Names.Request,
            eventName: EmployeeEvents.Save.Names.Request,
            EmployeeMap: employeeMap.data,
        }
        return event;
      }
    }
  
  static Add = {
    Names: {
      Request: "EmployeeAddRequestEvent",
      Response: "EmployeeAddResponseEvent",
    },
    Errors: {
      
    },
    Request: function(kvps, sendEmail=false) {
      var event = {
          handler: "EmployeeAddRequestEvent",
          eventName: "EmployeeAddRequestEvent",
          version: 2,
      }

      let user = kvps.user();
      kvps.remove("User");
      
      const params = {
        Employee: kvps.data,
        User: user.data,
      };
      params["sendEmail"] = sendEmail;
      event["Params"] = params;
      return event;
    }
  }
  
  static Resend = {
    Names: {
      Request: "EmployeeReinviteRequestEvent",
      Response: "EmployeeReinviteResponseEvent",
    },
    Errors: {
      
    },
    Request: function(company, user) {
      var event = {
          handler: EmployeeEvents.Resend.Names.Request,
          eventName: EmployeeEvents.Resend.Names.Request,
          User: user.id(),
          Company: company.id(),
      }
      return event;
    }
  }
  
  static Remove = {
    Names: {
      Request: "EmployeeRemoveRequestEvent",
      Response: "EmployeeRemoveResponseEvent",
    },
    Errors: {
      
    },
    Request: function(userToRemove) {
      var event = {
          handler: EmployeeEvents.Remove.Names.Request,
          eventName: EmployeeEvents.Remove.Names.Request,
      }
      if (userToRemove.data) {
        event["removeEmployee"] = userToRemove.data;
      } else {
        event["removeEmployee"] = userToRemove;
      }
      return event;
    }
  }
  
  static Restore = {
      Names: {
        Request: "EmployeeRestoreRequestEvent",
        Response: "EmployeeRestoreResponseEvent",
      },
      Errors: {
        
      },
      Request: function(employee) {
        var event = {
            handler: EmployeeEvents.Restore.Names.Request,
            eventName: EmployeeEvents.Restore.Names.Request,
        }
        if (employee.data) {
          event['restoreEmployee'] = employee.data;
        } else {
          event['restoreEmployee'] = employee;
        }
        return event;
      }
    }
  
  static List = {
    Names: {
      Response: 'EmployeeListResponseEvent',
      Request: 'EmployeeListRequestEvent',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: ''
      },
    },

    Request: function(filter) {
      const event = {
          handler: EmployeeEvents.List.Names.Request,
          eventName: EmployeeEvents.List.Names.Request,
          filter: filter.data,
      };
      return event;
    },
  }

  import(params) {
    var event = EmployeeEvents.Import.Operation(params);
    return this.eventsDomain.initRequest(event);
  }

  static Import = {
    Names: {
      Request: 'EmployeeImportCommandOperation',
      Response: 'EmployeeImportNotification',
    },
    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: ''
      },
    },
    Operation: function(data) {
      var event = {
        eventName: this.Names.Request,
        handler: this.Names.Request,
      }
      var params = {
        files: data,
        companyId: data.companyId,
      }
      event["Params"] = params;
      return event;
    },
  }

  export(params) {
    var event = EmployeeEvents.Export.Operation(params);
    return this.eventsDomain.initRequest(event);
  }

  static Export = {
    Names: {
      Request: 'ExportEmployeesQueryOperation',
      Response: 'ExportEmployeesNotification',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: ''
      },
    },

    Operation: function(data) {
      var event = {
        eventName: this.Names.Request,
        handler: this.Names.Request,
      }

      var params = {
        filter: data,
      }

      event["Params"] = params;
      return event;
    },
  }

}
